<template>
  <div class="filepicker-title">
    <div class="filepicker-title-left">
      <img :class="connector + '-filepicker-logo'" :src="logo"/>
      <span class="filepicker-title-text">Choose File(s)</span>
    </div>
    <div>
      <span v-if="user">
        <span v-if="connector === 'github'" class="filepicker-user-text">
          <a :href="'https://github.com/' + user" target="_blank"> @{{ user }}</a>
        </span>
        <span v-else class="filepicker-user-text">
          {{ user }} <span v-if="domain">({{ domain }})</span>
        </span>
      </span>
      <span v-if="locale">
        {{ locale }}
      </span>
      <span class="close-icon" :class="connector + '-filepicker-title-close'"
            @click.prevent="$emit('close-filepicker')">✕</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilePickerHeader",
  props: [
    'logo',
    'connector',
    'onClose',
    'user',
    'domain',
    'locale'
  ],
  data: function () {
    return {};
  },
};
</script>

<style scoped>

</style>
